var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBlockPlane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 104,
    viewBox: "0 0 135 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BLOC PLANE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON PLANE"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M74.5104 11.6999C54.0204 -7.45011 12.7204 0.229893 8.43035 35.8999C8.22035 37.6599 8.11035 39.4199 8.11035 41.1899C8.11035 74.1099 35.1904 80.7899 47.1604 80.7899C63.1104 80.7899 85.9203 72.6099 85.9203 39.6899C85.9203 38.9999 85.9004 38.3199 85.8704 37.6299C85.4504 29.0199 82.7904 21.9299 78.6904 16.3799",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M41.3899 13.09L44.9997 10.52L65.1197 18.8L72.1797 12.9C73.3997 11.88 74.8997 11.25 76.4897 11.08L77.4897 10.98C78.7497 10.85 79.8497 11.82 79.8697 13.09V13.42C79.8997 14.82 79.3597 16.18 78.3697 17.18L71.5597 24.83L77.1597 46.51L73.8797 50.05L63.3497 31.44L54.8197 38.35L51.8097 40.48L53.1297 47.25L51.2297 48.79L47.2797 42.94L44.1897 43.13L44.8897 40.25L39.8497 35.19L41.3897 33.01L47.4697 35.74L56.4797 25.18L39.6497 14.52L41.3899 13.09Z",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.23033 47.41C8.23033 47.41 -5.66967 61.17 6.47033 64.53C18.6103 67.89 44.2303 43.02 44.2303 43.02",
    stroke: "#EF7056",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "ICON LINES"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M102.529 101.73L90.2583 87.033",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M126.252 58.9825L101.313 57.8433",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M95.9768 72.0079L125.786 88.8754",
    stroke: "#EF7056",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlockPlane);
export default __webpack_public_path__ + "static/media/icon-block-plane.1ee33812b6560ac68796cb0a96d20f1b.svg";
export { ForwardRef as ReactComponent };